import Icon from '@mui/icons-material/Hub'

export default {
  name: 'hubs',
  recordRepresentation: 'name',
  options: {
    defaultSort: { field: 'name', order: 'ASC' },
    referenceKey: 'hub_id',
    references: ['vehicles', 'bookings', 'incident-reports'],
    showResource: 'organisations',
  },
  icon: Icon,
}
